import type { ReactNode } from "react";
import { StyleSheet, Text } from "react-native";

import { AppText } from "./AppText";
import { Card } from "./Card";
import { fonts, useThemedStyles, type ThemeColors } from "~/styles/theme";

export function MetricCard({
  label,
  value,
  hint,
  accent = "none",
}: {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  accent?: "none" | "mint" | "danger";
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <Card gap="xs" compact accent={accent}>
      <AppText size="xs" tone="muted" weight="medium">
        {label}
      </AppText>
      {typeof value === "string" || typeof value === "number" ? (
        <Text style={stylesheet.value}>{value}</Text>
      ) : (
        value
      )}
      {hint ? (
        <AppText size="xs" tone="muted">
          {hint}
        </AppText>
      ) : null}
    </Card>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    value: {
      color: colors.heading,
      fontFamily: fonts.bold,
      fontSize: 28,
      lineHeight: 32,
      letterSpacing: -0.5,
    },
  });
